<template>
  <div class="auth-view-container">
    <div id="firebaseui-auth-container"></div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import firebaseui from "firebaseui";
import { mapActions } from "vuex";

export default {
  name: "LoginView",
  mounted() {
    this.setPageType("login");
    let uiConfig = {
      signInSuccessUrl: "/profil",
      signInFlow: 'popup',
      signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID,
      ],
      tosUrl: "/impressum",
      privacyPolicyUrl: "/impressum",
    };
    let ui = firebaseui.auth.AuthUI.getInstance();
    if (!ui) {
      ui = new firebaseui.auth.AuthUI(firebase.auth());
      ui.start("#firebaseui-auth-container", uiConfig);
    } else {
    console.log(ui);
      if (ui.isPendingRedirect()) {
        ui.start("#firebaseui-auth-container", uiConfig);
      }
    }
  },
  methods: {
    ...mapActions(["setPageType"]),
  },
};
</script>

<style lang="scss">
@import "../../node_modules/firebaseui/dist/firebaseui.css";

#firebaseui-auth-container {
  margin-top: 20px;
}
</style>
